export default {
  common: {
    appName: 'mediAI',
    tagline: 'AI Destekli İçerik Platformu',
    phase: 'Faz 1 - PoC',
    loading: 'Yükleniyor...',
    save: 'Kaydet',
    saved: 'Kaydedildi',
    cancel: 'İptal',
    close: 'Kapat',
    edit: 'Düzenle',
    delete: 'Sil',
    update: 'Güncelle',
    export: 'Dışa Aktar',
    detail: 'Detay',
    user: 'Kullanıcı',
    status: {
      active: 'Aktif',
      inactive: 'Pasif',
      published: 'Yayınlandı',
      draft: 'Taslak',
      rejected: 'Reddedildi',
      pending: 'Bekliyor',
      analyzing: 'Analiz Ediliyor',
      completed: 'Tamamlandı',
      error: 'Hata',
    },
  },
  roles: {
    admin: 'Yönetici',
    editor: 'Editör',
    writer: 'Yazar',
  },
  sites: {
    all: 'Tüm Siteler',
    samanyolu: 'Samanyolu Haber',
    aktif: 'Aktif Haber',
    bold: 'Bold Medya',
    unknown: 'Bilinmeyen Site',
  },
  errors: {
    INVALID_CREDENTIALS: 'Kullanıcı adı veya şifre hatalı.',
    NOT_AUTHENTICATED: 'Bu işlem için giriş yapmanız gerekiyor.',
    NO_ROLES: 'Bu hesaba erişim izni verilmemiş.',
    EMPTY_CREDENTIALS: 'Kullanıcı adı ve şifre boş olamaz.',
    network: 'Sunucuya bağlanılamadı.',
    unknown: 'Beklenmeyen bir hata oluştu.',
  },
  nav: {
    dashboard: 'Dashboard',
    styleProfiling: 'Stil Profilleme',
    newsInput: 'Haber Girişi',
    contentGeneration: 'İçerik Üretimi',
    publishing: 'Yayınlama',
    contentArchive: 'İçerik Arşivi',
    userManagement: 'Kullanıcı Yönetimi',
  },
  sidebar: {
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
    userMenu: 'Kullanıcı menüsü',
    logout: 'Çıkış Yap',
    supportedSites: 'Desteklenen Siteler:',
  },
  auth: {
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    welcome: 'Hoş Geldiniz',
    createAccount: 'Hesap Oluştur',
    loginSubtitle: 'Devam etmek için giriş yapın',
    registerSubtitle: 'Yeni hesap oluşturmak için bilgilerinizi girin',
    fullName: 'Ad Soyad',
    fullNamePlaceholder: 'Adınız Soyadınız',
    accountType: 'Hesap Türü',
    roleHint: 'Rolünüze göre farklı sayfalara erişebilirsiniz.',
    email: 'E-posta',
    emailPlaceholder: 'ornek@email.com',
    username: 'Kullanıcı Adı',
    usernamePlaceholder: 'kullaniciadi',
    password: 'Şifre',
    passwordPlaceholder: '••••••••',
    passwordHint: 'En az 6 karakter',
    loggingIn: 'Giriş yapılıyor...',
    registering: 'Kayıt yapılıyor...',
    pitch: {
      headline: 'AI ile İçerik Üretiminde Yeni Dönem',
      body: 'mediAI platformu ile haber siteleriniz için özgün stil profilleri oluşturun ve AI destekli içerikler üretin.',
      styleProfiling: 'Stil Profilleme',
      styleProfilingDesc: 'Her haber sitesi için özgün stil analizi',
      humanReview: 'İnsan Denetimi',
      humanReviewDesc: 'Editör onay süreci ile kalite kontrolü',
      wordpress: 'WordPress Entegrasyonu',
      wordpressDesc: 'Direkt CMS yayınlama desteği',
      siteCount: '3 Haber Sitesi',
      sites: 'Samanyolu Haber • Aktif Haber • Bold Medya',
    },
  },
  dashboard: {
    welcome: 'Hoş Geldiniz, {name}!',
    subtitle: 'mediAI.com Platform Özeti',
    totalContent: 'Toplam İçerik',
    pendingApproval: 'Onay Bekleyen',
    published: 'Yayınlanan',
    apiCredit: 'API Kredi',
    tokenUsage: 'Token Kullanımı',
    tokenAverage: 'Ortalama: {value} token/gün',
    recentActivity: 'Son Aktiviteler',
    apiStatus: 'API Durumu',
    allSystemsNormal: 'Tüm sistemler normal çalışıyor',
    avgResponse: 'Ortalama Yanıt',
    successRate: 'Başarı Oranı',
    rateLimit: 'Rate Limit',
    uptime: 'Uptime',
  },
  newsInput: {
    title: 'Haber Girişi',
    subtitle: 'Haber kaynağınızı seçin ve AI ile yeniden yorumlayın',
    step1: '1. Hedef Site Seçimi',
    selectedSite: 'Seçili Site:',
    siteHint: 'İçerik bu sitenin stil profiline göre üretilecek',
    step2: '2. Haber Kaynağı',
    tabUrl: 'URL',
    tabManual: 'Manuel Metin',
    tabAgency: 'Ajans Haberleri',
    newsUrl: "Haber URL'si",
    urlPlaceholder: 'https://example.com/haber/...',
    urlHint: "Kaynak haberin URL'sini yapıştırın. İçerik otomatik olarak çekilecektir.",
    newsText: 'Haber Metni',
    textPlaceholder: 'Haber metnini buraya yapıştırın...',
    textHint: 'Ham haber metnini manuel olarak girebilirsiniz.',
    agencyHint: 'Haber ajanslarından gelen haberleri seçin (birden fazla seçilebilir)',
    selectedCount: '{n} haber seçildi',
    generate: 'AI ile İçerik Üret',
    generating: 'İçerik Üretiliyor...',
    noProfile: 'Stil profili yok',
    errors: {
      noSite: 'Lütfen bir haber sitesi seçin',
      noUrl: "Lütfen haber URL'si girin",
      noText: 'Lütfen haber metni girin',
      noNews: 'Lütfen en az bir haber seçin',
      noStyleProfile:
        'Bu site için henüz stil profili oluşturulmamış. Lütfen önce Stil Profilleme sayfasından analiz yapın.',
      generationFailed: 'İçerik üretimi sırasında bir hata oluştu. Lütfen tekrar deneyin.',
    },
  },
  contentGeneration: {
    title: 'İçerik Üretimi & Editör Paneli',
    site: 'Site:',
    styleScore: 'Stil Uyum Puanı',
    save: 'Kaydet',
    saved: 'Kaydedildi',
    sendForPublish: 'Yayınlamaya Gönder',
    editMode: 'Düzenleme Modu',
    compareMode: 'Karşılaştırma Görünümü',
    aiGenerated: 'AI Tarafından Üretildi',
    fieldTitle: 'Başlık',
    fieldIntro: 'Giriş',
    fieldBody: 'Gelişme',
    fieldRelatedNews: 'İlgili Haberler',
    fieldConclusion: 'Sonuç',
    aiSuggestions: 'AI Önerileri',
    originalNews: 'Orijinal Haber',
    sourceContent: 'Kaynak içerik',
    aiOutput: 'AI Üretimi',
    styleApplied: 'Stil profili uygulandı',
    vocabulary: 'Kelime Dağarcığı',
    sentenceStructure: 'Cümle Yapısı',
    toneMatch: 'Ton Uyumu',
    rhetoric: 'Retorik',
    lastUpdated: 'Son güncelleme:',
    noContent: 'İçerik bulunamadı',
    noContentHint: 'İçerik üretimi sayfasını kullanmak için önce',
    goToNewsInput: 'Haber Girişi sayfasına git',
    saveError: 'İçerik kaydedilemedi. Lütfen tekrar deneyin.',
  },
  styleProfiling: {
    title: 'Stil Profilleme Modülü',
    subtitle: 'Haber sitelerinin yazım stillerini analiz edin ve profil oluşturun',
    howTitle: 'Stil Profili Nasıl Oluşturulur?',
    howBody:
      'Her haber sitesi için son 50 haber analiz edilerek kelime dağarcığı, cümle yapısı, retorik özellikler ve ton düzeyi belirlenir. Bu profil, AI içerik üretiminde kullanılır.',
    viewDetails: 'Detayları Görüntüle',
    reanalyze: 'Yeniden Analiz Et',
    startAnalysis: 'Analiz Başlat',
    analyzedCount: 'Analiz Edilen Haber',
    lastUpdated: 'Son Güncelleme',
    avgSentenceLength: 'Ort. Cümle Uzunluğu:',
    vocabulary: 'Kelime Dağarcığı:',
    toneLevel: 'Ton Seviyesi:',
    metaphorUsage: 'Metafor Kullanımı:',
    styleProfile: 'Stil Profili',
    systemPromptSummary: 'Sistem İstemi Özeti',
    promptDesc:
      'Bu profil, AI modelinin {site} tarzında içerik üretmesi için kullanılır. Analiz sonuçları JSON formatında saklanır.',
    vocabPreferences: 'Kelime Tercihleri',
    vocabDesc: 'Profesyonel, sektöre özgü terimler tercih edilir',
    sentenceStructure: 'Cümle Yapısı',
    sentenceDesc: 'Orta uzunlukta, net ve anlaşılır cümleler',
    narrativeStyle: 'Anlatı Tarzı',
    narrativeDesc: 'Objektif ve bilgilendirici yaklaşım',
    uploadJson: 'Makale JSON Yükle',
    downloadProfile: 'JSON Profili İndir',
    selectSiteHint: 'Profil detaylarını görmek için bir site seçin',
  },
  publishing: {
    title: 'Yayınlama & CMS Entegrasyonu',
    subtitle: "WordPress'e yayınlamak için son düzenlemeleri yapın",
    successTitle: 'Başarıyla Yayınlandı!',
    successBody: "İçerik WordPress'e {status} gönderildi.",
    asDraft: 'taslak olarak',
    preview: 'İçerik Önizleme',
    placeholderTitle: 'Başlık',
    placeholderIntro: 'Giriş metni',
    placeholderBody: 'Ana metin içeriği',
    placeholderConclusion: 'Sonuç',
    imageGallery: 'Görsel Galerisi',
    sampleImages: 'Örnek görseller:',
    imageLabel: 'Görsel {n}',
    featured: 'Öne Çıkan',
    wpSettings: 'WordPress Ayarları',
    publishStatus: 'Yayın Durumu',
    statusDraft: 'Taslak',
    statusPublish: 'Yayınla',
    publishDate: 'Yayın Tarihi (Opsiyonel)',
    publishDateHint: 'Boş bırakırsanız hemen yayınlanır',
    categories: 'Kategoriler',
    tags: 'Etiketler',
    tagPlaceholder: "Etiket ekle ve Enter'a bas",
    wpConnection: 'WordPress Bağlantısı',
    connectionActive: 'API bağlantısı aktif ve hazır',
    sending: 'Gönderiliyor...',
    sendToWp: "WordPress'e Gönder",
    draftNote: 'İçerik taslak olarak kaydedilecek. Yayınlamak için durumu değiştirin.',
  },
  archive: {
    title: 'İçerik Arşivi',
    subtitle: 'Oluşturulan ve yayınlanan tüm içerikleri görüntüleyin',
    totalContent: 'Toplam İçerik',
    totalViews: 'Toplam Görüntüleme',
    avgStyleScore: 'Ort. Stil Puanı',
    searchPlaceholder: 'İçerik ara (başlık veya yazar)...',
    allStatuses: 'Tüm Durumlar',
    views: 'görüntüleme',
    source: 'Kaynak:',
    viewSource: 'Kaynağı Görüntüle',
    contentDetail: 'İçerik Detayı',
    originalNews: 'Orijinal Haber',
    generatedContent: 'Üretilen İçerik',
    styleAnalysis: 'Stil Uyum Analizi',
    publishInfo: 'Yayın Bilgileri',
    publishedTo: 'Yayınlandığı Siteler:',
    publishedBy: 'Yayınlayan:',
    publishedAt: 'Yayın Tarihi:',
    createInfo: 'Oluşturma Bilgileri',
    createdBy: 'Oluşturan:',
    createdAt: 'Oluşturma Tarihi:',
    generateForSite: 'Başka Site İçin Üret',
    generateForSiteTitle: 'Hangi site için üretilsin?',
    generateBtn: 'Üret',
    loadError: 'İçerikler yüklenirken bir hata oluştu.',
  },
  users: {
    title: 'Kullanıcı Yönetimi',
    subtitle: 'Sistem kullanıcılarını yönetin ve yetkilendirin',
    total: 'Toplam',
    searchPlaceholder: 'Kullanıcı ara...',
    allRoles: 'Tüm Roller',
    addUser: 'Kullanıcı Ekle',
    colUser: 'Kullanıcı',
    colRole: 'Rol',
    colStatus: 'Durum',
    colSites: 'Siteler',
    colActions: 'İşlem',
    editUser: 'Kullanıcı Düzenle',
    newUser: 'Yeni Kullanıcı',
    fullName: 'Ad Soyad',
    fullNamePlaceholder: 'Ad Soyad',
    email: 'E-posta',
    emailPlaceholder: 'ornek@email.com',
    role: 'Rol',
    status: 'Durum',
    siteAccess: 'Site Erişimi',
    errors: {
      noSite: 'En az bir site seçilmelidir',
    },
    toasts: {
      updated: 'Kullanıcı güncellendi',
      added: 'Kullanıcı eklendi',
      deleted: 'Kullanıcı silindi',
      confirmDelete: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
      confirmDeleteAction: 'Sil',
      confirmDeleteCancel: 'İptal',
    },
  },
  presentation: {
    exit: 'Çıkış',
    newsHeadline: 'AI ile İçerik Üretiminde Yeni Dönem',
    newsSites: 'Haber Sitesi',
    aiAnalysis: 'Destekli Analiz',
    cmsIntegration: 'Entegrasyonu',
    slides: [
      { title: 'mediAI Platform', description: 'AI Destekli Haber İçerik Üretim Sistemi - Faz 1 PoC' },
      {
        title: 'Kullanıcı Girişi',
        description: 'Rol bazlı yetkilendirme sistemi (Admin, Editör, Yazar) – Firebase Auth ile giriş ve kayıt.',
      },
      { title: 'Dashboard', description: 'Platform özeti, token kullanımı ve aktivite takibi.' },
      { title: 'Stil Profilleme Modülü', description: 'Her haber sitesi için özgün stil analizi ve profil oluşturma.' },
      { title: 'Haber Girişi', description: 'URL, manuel metin veya ajans haberleri ile içerik kaynağı seçimi.' },
      { title: 'İçerik Üretimi & Editör Paneli', description: 'AI üretimi, insan denetimi ve stil uyum puanlaması.' },
      { title: 'Yayınlama & CMS Entegrasyonu', description: 'WordPress entegrasyonu ile içerik yayınlama.' },
      { title: 'İçerik Arşivi', description: 'Oluşturulan ve yayınlanan tüm içerikleri görüntüleme ve filtreleme.' },
      { title: 'Kullanıcı Yönetimi', description: 'Sistem kullanıcılarını yönetme ve yetkilendirme (Admin).' },
    ],
  },
  placeholder: {
    comingSoon: 'Bu bölüm yakında eklenecek.',
  },
  htmlEditor: {
    bold: 'Kalın',
    italic: 'İtalik',
    heading2: 'Başlık 2',
    heading3: 'Başlık 3',
    bulletList: 'Madde listesi',
    orderedList: 'Numaralı liste',
    blockquote: 'Alıntı',
    undo: 'Geri al',
    redo: 'Yinele',
  },
}
